import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DebugSnackbarComponent } from './debug-snackbar/debug-snackbar.component';
import { AlertsService } from './alerts.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ActionSnackbarComponent } from './action-snackbar/action-snackbar.component';


@NgModule({
    declarations: [DebugSnackbarComponent, ActionSnackbarComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule
    ],
    providers: [AlertsService],
    exports: [
        MatSnackBarModule,
        CommonModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class AlertsModule {}
